import React from "react";
import { MDBBtn, MDBCol, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBRow } from "mdb-react-ui-kit";
import request from "../util/client";
import Toast from "../component/toast";
import Loading from "../component/loading";
import { hasLoggedIn, setToken } from "../util/token";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function Login() {
  const [show, setShow] = React.useState(false);
  const [qrcode, setQrcode] = React.useState({});
  const [isExpired, setExpired] = React.useState(false);
  const onLoggedIn = React.useRef((token, data) => {
    setToken(token);
    let ev = new Event('loginstatuschange');
    ev.data = data;
    window.localStorage.setItem('info', JSON.stringify(data));
    setShow(false);
    loading.current.hide();
    toast.current.show('登录成功', 'success').then(() => {
      document.dispatchEvent(ev);
    });
  });
  const doLogin = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    if (e.target.checkValidity()) {
      let fd = new FormData(e.target);
      loading.current.show();
      request('login/account_login', 'POST', fd).then(result => {
        onLoggedIn.current(result.data.token, { avatar: result.data.avatarUrl, nickname: result.data.nickname, id: result.data.memberId });
      }, error => {
        loading.current.hide();
        toast.current.show(error || '登录发生错误', 'danger');
      });
    }
  });
  const expired = React.useRef(0);
  const check = React.useRef(0);
  const loadQrcode = React.useRef(() => {
    return new Promise((resolve, reject) => {
      request('my/loginQRCode', 'POST').then(response => {
        setQrcode(response.data || {});
        setExpired(false);
        expired.current = window.setTimeout(() => {
          setExpired(true);
        }, 100000);
        resolve();
      }, reject);
    });
  });
  React.useEffect(() => {
    const onHide = () => {
      check.current && window.clearInterval(check.current);
      check.current = 0;
    };
    if (qrcode.loginKey && !isExpired) {
      check.current && window.clearInterval(check.current);
      check.current = window.setInterval(() => {
        request('my/isScanQRCode', 'POST', { loginKey: qrcode.loginKey }).then(response => {
          onLoggedIn.current(response.data.token, { avatar: response.data.avatarUrl, nickname: response.data.nickname, id: response.data.memberId });
        }, () => {});
      }, 3000);
    } else {
      onHide();
    }
  }, [qrcode.loginKey, isExpired]);
  React.useEffect(() => {
    const onHide = () => {
      expired.current && window.clearTimeout(expired.current);
      expired.current = 0;
      check.current && window.clearInterval(check.current);
      check.current = 0;
      setQrcode({});
    };
    if (show) {
      loadQrcode.current();
    } else {
      onHide();
    }
  }, [show]);
  React.useEffect(() => {
    window.document.addEventListener('login', () => {
      if (!hasLoggedIn()) {
        setShow(true);
      }
    });
  }, []);
  const toast = React.useRef();
  const loading = React.useRef();
  return (
    <>
      <MDBModal show={show} setShow={setShow} tabIndex='-1'>
        <MDBModalDialog className="login-panel" centered>
          <MDBModalContent>
            <MDBModalBody className="px-4 py-5">
              <MDBRow className="align-items-center">
                <MDBCol size="6" className="desc d-none d-md-block text-center">
                  <img src="https://res.hilinky.com.au/logo-wide.png" className="d-block mx-auto" width="185" height="97.5" alt="" />
                  <div className="d-inline-block position-relative">
                    <img src={qrcode.qrCodeUrl} width="150" height="150" alt="" />
                    {isExpired ? (
                      <span className="expired" onClick={loadQrcode.current}>已过期<br />点击刷新</span>
                    ) : null}
                  </div>
                  <h6 className="fw-bold mt-3 mb-2">打开Linky APP扫描二维码</h6>
                  <p className="mb-0">从Linky“我的”左上角点击 <FontAwesomeIcon icon={faBars} /> 找到扫一扫</p>
                </MDBCol>
                <MDBCol size="12" md="6" tag="form" onSubmit={doLogin.current}>
                  <h3 className="legend text-center pb-4">欢迎登录</h3>
                  <input type="hidden" name="areaCode" value="61" />
                  <MDBInput
                    type="text"
                    label="手机号/邮箱"
                    name="loginAccount"
                    wrapperClass="mb-4"
                    spellCheck={false}
                    autoComplete="off"
                    size="lg"
                    required
                  />
                  <MDBInput
                    type="password"
                    label="密码"
                    name="password"
                    wrapperClass="mb-4"
                    spellCheck={false}
                    autoComplete="off"
                    size="lg"
                    required
                  />
                  <MDBBtn type='submit' block size="lg">登录</MDBBtn>
                  <div className="form-check mt-3 agreement">
                    <input className="form-check-input" type="checkbox" id="agreement" required />
                    <label className="form-check-label" htmlFor="agreement">我已阅读并同意</label>
                    <a href="https://www.hilinky.com.au/agreement/" target="_blank" rel="noreferrer">《用户协议》</a>
                    <label className="form-check-label" htmlFor="agreement">和</label>
                    <a href="https://www.hilinky.com.au/private-policies/" target="_blank" rel="noreferrer">《隐私政策》</a>
                  </div>
                </MDBCol>
              </MDBRow>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <Loading ref={loading} />
      <Toast ref={toast} />
    </>
  );
};
